export default __webpack_public_path__ + "static/media/office.56edc19a.png";